import colorsPdvend from "./pdvend";
import colorsMhi from "./mhi";

const envToColorsMap = {
  PDVEND: colorsPdvend,
  MHI: colorsMhi
};

const colors = envToColorsMap[process.env.REACT_APP_WHITELABEL_NAME];

export default colors;



// WEBPACK FOOTER //
// ./src/assets/colors/index.js